import { useMemo } from "react";
import {
  DEFAULT_PAGE_SIZE,
  resolveCandidateTableKey,
  resolveCommonTableKey,
} from "helpers/GeneralHelper";
import { useTablePageSizePreference } from "libs/context/TablePageSizePreferencesContext";

/**
 * Wait for user-settings page size sync, then use that size for the first filter API call.
 * @param {string} tableKey - Must match TableContainer / CandidateTableContainer resolved key
 * @param {number} [defaultPageSize]
 */
export const useSettingsReadyTablePageSize = (
  tableKey = "",
  defaultPageSize = DEFAULT_PAGE_SIZE
) => {
  const { pageSize, settingsReady, setPageSize } = useTablePageSizePreference(
    tableKey,
    defaultPageSize
  );

  const resolvedPageSize = useMemo(
    () => Number(pageSize) || defaultPageSize,
    [pageSize, defaultPageSize]
  );

  return {
    settingsReady,
    pageSize: resolvedPageSize,
    setPageSize,
  };
};

/** TableContainer pages: pass the same `pageName` (and optional tableKey) as the table. */
export const useCommonTableSettingsPageSize = (
  pageName = "",
  tableKeyProp,
  defaultPageSize = DEFAULT_PAGE_SIZE
) =>
  useSettingsReadyTablePageSize(
    resolveCommonTableKey(pageName, tableKeyProp),
    defaultPageSize
  );

/** CandidateTableContainer / CandidateOnboardingTableContainer pages. */
export const useCandidateTableSettingsPageSize = (
  pageName = "",
  tableKeyProp,
  defaultPageSize = DEFAULT_PAGE_SIZE
) =>
  useSettingsReadyTablePageSize(
    resolveCandidateTableKey(pageName, tableKeyProp),
    defaultPageSize
  );

export default useSettingsReadyTablePageSize;
